import { IAppContext } from 'App/AppContext';
import { IGraphInterface } from 'App/AppContextProvider';
import { isBrokeredProvider } from 'models/documentProvider';
import ResourceLink from 'models/resourceLink';
import {
  getEmbedURLBrokered,
  getThumbnailBrokered,
  getWebURLBrokered,
  isValidBrokered,
  publishBrokered,
  setMetaDataBrokered,
} from './brokeredLinkContent';
import {
  getEmbedURLSharePoint,
  getThumbnailSharePoint,
  getWebURLSharePoint,
  isValidSharePoint,
  publishSharePoint,
  setMetaDataSharePoint,
} from './sharePointLinkContent';

/**
 * Picks the transport for a library item's content: direct Graph from the browser for a
 * SharePoint or virtual category, the API broker for everything else.
 *
 * This is the only place allowed to branch on the provider type. Whether a user may do
 * something is answered by the provider capabilities, never here.
 */

export async function getLinkWebURL(link: ResourceLink, appContext: IAppContext): Promise<string> {
  if (isBrokeredProvider(link.list)) {
    return await getWebURLBrokered(link, appContext);
  }

  return await getWebURLSharePoint(link, appContext);
}

export async function getLinkEmbedURL(link: ResourceLink, appContext: IAppContext): Promise<string | undefined> {
  if (isBrokeredProvider(link.list)) {
    return await getEmbedURLBrokered(link, appContext);
  }

  return await getEmbedURLSharePoint(link, appContext);
}

export async function getLinkThumbnail(link: ResourceLink, appContext: IAppContext): Promise<string> {
  if (isBrokeredProvider(link.list)) {
    return await getThumbnailBrokered();
  }

  return await getThumbnailSharePoint(link, appContext);
}

export async function setLinkMetaData(
  link: ResourceLink,
  graphInterfacePages: IGraphInterface | undefined,
  graphInterfaceDocuments: IGraphInterface | undefined,
  appContext: IAppContext,
): Promise<void> {
  if (isBrokeredProvider(link.list)) {
    return await setMetaDataBrokered(link, appContext);
  }

  return await setMetaDataSharePoint(link, graphInterfacePages, graphInterfaceDocuments, appContext);
}

export async function publishLink(link: ResourceLink, appContext: IAppContext): Promise<void> {
  if (isBrokeredProvider(link.list)) {
    return await publishBrokered();
  }

  return await publishSharePoint(link, appContext);
}

export async function isLinkValid(link: ResourceLink, appContext: IAppContext): Promise<boolean | undefined> {
  if (isBrokeredProvider(link.list)) {
    return await isValidBrokered(link, appContext);
  }

  return await isValidSharePoint(link, appContext);
}
